import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'discountPercent',
  standalone: true,
})
export class DiscountPercentPipe implements PipeTransform {
  transform(originalPrice: number, discountedPrice: number): string {
    return '-' + ((100 * (originalPrice - discountedPrice)) / originalPrice).toFixed() + '%';
  }
}
